import { api } from '../api';
import { apiSensedia } from '../api-sensedia';

type DataQuery = {
  cpf?: string;
  nome?: string;
  produto?: string;
  status?: string;
};

const CARTEIRA_PREVIDENCIA_REQUEST_TIMEOUT_MS = Number(
  process.env.REACT_APP_CARTEIRA_PREVIDENCIA_REQUEST_TIMEOUT_MS || 5500
);

const CARTEIRA_PREVIDENCIA_POLLING_MAX_ATTEMPTS = Number(
  process.env.REACT_APP_CARTEIRA_PREVIDENCIA_POLLING_MAX_ATTEMPTS || 20
);

const CARTEIRA_PREVIDENCIA_POLLING_INTERVAL_MS = Number(
  process.env.REACT_APP_CARTEIRA_PREVIDENCIA_POLLING_INTERVAL_MS || 2000
);

const wait = (ms: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, ms));

const buildDataRequest = (
  page = 0,
  { cpf = '', nome = '', produto = '', status = '' }: DataQuery = {}
) => {
  const params = {
    page: String(page),
    nome,
    cpf,
    produto,
    status
  };

  const queriesParams = new URLSearchParams(params).toString();
  const requestUrl = `/gestao-de-carteiras/carteira-previdencia-individual?${queriesParams}`;

  return {
    requestUrl,
    cpf
  };
};

export const getData = async (
  page = 0,
  { cpf = '', nome = '', produto = '', status = '' }: DataQuery = {}
) => {
  const { requestUrl, cpf: cpfHeader } = buildDataRequest(page, {
    cpf,
    nome,
    produto,
    status
  });

  const response = await apiSensedia.get(requestUrl, {
    headers: { cpf: cpfHeader }
  });

  return response.data.data;
};

export const getDataWithPolling = async (
  page = 0,
  dataQuery: DataQuery = {}
) => {
  const { requestUrl, cpf } = buildDataRequest(page, dataQuery);

  for (
    let attempt = 1;
    attempt <= CARTEIRA_PREVIDENCIA_POLLING_MAX_ATTEMPTS;
    attempt++
  ) {
    try {
      const response = await apiSensedia.get(requestUrl, {
        headers: { cpf },
        timeout: CARTEIRA_PREVIDENCIA_REQUEST_TIMEOUT_MS
      });

      const inProgress =
        response.status === 202 || response?.data?.status === 'in_progress';

      if (!inProgress) {
        return response.data.data;
      }

      const retryAfterMs = Number(
        response?.data?.retryAfterMs || CARTEIRA_PREVIDENCIA_POLLING_INTERVAL_MS
      );

      if (attempt < CARTEIRA_PREVIDENCIA_POLLING_MAX_ATTEMPTS) {
        await wait(retryAfterMs);
      }
    } catch (error: any) {
      const status = error?.response?.status;

      if (
        status === 504 &&
        attempt < CARTEIRA_PREVIDENCIA_POLLING_MAX_ATTEMPTS
      ) {
        await wait(CARTEIRA_PREVIDENCIA_POLLING_INTERVAL_MS);
        continue;
      }

      throw error;
    }
  }

  throw new Error('CARTEIRA_PREVIDENCIA_POLLING_TIMEOUT');
};

export const getTotalCountRegisters = async () => {
  const requestUrl = `/gestao-de-carteiras/carteira-previdencia-individual/count`;

  const response = await apiSensedia.get(requestUrl, { timeout: 6000 });

  return response.data.data;
};

export const getTotalSum = async () => {
  const requestUrl = `/gestao-de-carteiras/carteira-previdencia-individual/total`;

  const response = await apiSensedia.get(requestUrl, { timeout: 6000 });

  console.log(response);

  return response.data?.data?.valor_saldo;
};

export const getConsents = async () => {
  const requestUrl = `/consentimentos`;
  const response = await apiSensedia.get(requestUrl, { timeout: 6000 });
  return response.data;
};

export type RequestConsentByCPFProps = {
  cpf: string;
  email?: string | null;
  celular?: string | null;
  type?: 'celular' | 'email';
};
export const requestConsentByCpf = async ({
  cpf,
  email,
  celular,
  type
}: RequestConsentByCPFProps) => {
  const requestUrl = `/consentimentos/solicitar-cpf`;
  const response = await apiSensedia.post(
    requestUrl,
    { email, celular, type },
    {
      timeout: 6000,
      headers: { cpf }
    }
  );
  return response.data;
};

export const requestAllConsentsByEv = async ({
  type
}: {
  type?: 'celular' | 'email';
}) => {
  const requestUrl = `/consentimentos/solicitar-todos`;
  const response = await apiSensedia.post(
    requestUrl,
    { type },
    {
      timeout: 6000
    }
  );
  return response.data;
};
